import axios from 'axios'
import store from '@/store'
import {baseURL} from '@/config'
import { Toast,
    Dialog } from 'vant';

// 创建axios实例
const service = axios.create({
    // baseURL: '/apis',
    baseURL,
    timeout: 15000
});
// request拦截器
service.interceptors.request.use(
    config => {
        let type = config.method === 'get' ? 'params' : 'data';
        if (config[type] === undefined) config[type] = {};
        let {
            token
        } = store.state.tokenInfo;
        config[type] = {
            ...config[type],
        };
        config.headers.Authorization = token
        return config;
    },
    error => {
        Promise.reject(error)
    }
)
//respone拦截器
service.interceptors.response.use(
    response => {
        console.log('response: ', response)
        if (response.status === 200) {
            if (response.data.code === 200) {
                response.data.ok = true
                return response.data
            } else if (response.data.code === 302) {
                Toast(response.data.message);
                store.dispatch("saveToken", {});
                localStorage.removeItem('loginInfo');
                window.location.reload();
            } else {
                console.log(response.data.message)
                Toast(response.data.message);
                response.data.ok = false
                return response.data
            }
        } else {
            Toast(response.statusText);
            return Promise.reject(response.statusText)
        }
    },
    error => {
        return Promise.reject(error)
    }
)

export default class Api {
    static post(url, data) {
        return service({
            url,
            method: 'post',
            data
        })
    }

    static get(url, params) {
        return service({
            url,
            method: 'get',
            params
        })
    }
}
